<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/4 xl:w-1/4 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <!-- <div class="vx-col hidden lg:block lg:w-1/2">
               <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
             </div>-->

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="px-4 pt-1 login-tabs-container flex items-stretch flex-col justify-center ">
                <img src="@/assets/images/logo.svg" width="120px" height="120px" class="mx-auto">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">
                    ورود
                  </h4>
                  <p>به آسکو خوش آمدید.</p>
                </div>
                <div>
                  <vs-input
                          v-validate="'required|min:3'"
                          data-vv-validate-on="blur"
                          name="mobile"
                          label-placeholder="شماره تلفن همراه یا ایمیل"
                          v-model="email"
                          @keydown.enter="loginJWT"
                          class="w-full"/>
                  <span class="text-danger text-sm">{{ errors.first('mobile') }}</span>

                  <vs-input
                          data-vv-validate-on="blur"
                          v-validate="'required'"
                          type="password"
                          name="password"
                          label-placeholder="رمز عبور"
                          v-model="password"
                          @keydown.enter="loginJWT"
                          class="w-full mt-8" />
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                  <div class="flex flex-wrap justify-between my-5">
                  <!--  <router-link to="/auth/forgot-password">
                      {{$t('Forgot Password')}}
                    </router-link>-->
                  </div>
                  <div class="flex flex-wrap justify-between mb-3 ">
                    <vs-button class="mx-auto" :disabled="!validateForm" @click="loginJWT" >
                      ورود
                    </vs-button>
                  </div>
                  <div>
                    <router-link to="/register/form">
                      آیا هنوز ثبت نام نکرده اید؟
                    </router-link>
                   <!-- <a-button type="link" @click="registerUser">
                      آیا هنوز ثبت نام نکرده اید؟
                    </a-button>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import axios from "../../http/axios";

  export default {
    data() {
      return {
        email: '',
        password: '',
        checkbox_remember_me: false
      }
    },
    computed: {
      validateForm() {
        return !this.errors.any() && this.email != '' && this.password != '';
      },
    },
    methods: {
      checkLogin() {
        // If user is already logged in notify
        if (this.$store.state.auth.isUserLoggedIn()) {
          // Close animation if passed as payload
          // this.$vs.loading.close()
          this.$vs.notify({
            title: '',
            text: 'You are already logged in!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          });
          return false
        }
        return true
      },
      async loginJWT() {
        if (!this.checkLogin()) return
        if (!this.validateForm) return

        // Loading
        this.$vs.loading()
        const payload = {
          userDetails: {
            email: this.email,
            password: this.password
          }
        };
        await this.$store.dispatch('auth/loginJWT', payload)
                .then(() => { this.$vs.loading.close() })
                .catch(({code , response}) => {
                  let msg = 'نام کاربری یا رمز عبور اشتباه است';//this.$t('Error Login ');
                  if(response && response.status == 422){
                    msg = response.data.message;
                  }
                  this.$vs.loading.close()
                  this.$message.error(msg);
                })
        try{
          let {data} = await axios.get('/permission/user')
          await this.$store.dispatch("access/setPermissions", data.permission)
          delete data.permission
          localStorage.setItem('userInfo',JSON.stringify(data))
        }
        catch (e) {
          console.log("eeeee: ",e)
        }
      },
      registerUser() {
        if (!this.checkLogin()) return
        this.$router.push('/auth/register').catch(() => {})
      }
    }
  }

</script>

<style lang="scss">
  .login-tabs-container {
    min-height: 505px;

    .con-tab {
      padding-bottom: 14px;
    }

    .con-slot-tabs {
      margin-top: 1rem;
    }
  }
</style>

